import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { ReactComponent as BonusIcon } from 'theme/assets/images/bonus-icon.svg';
import { dreamteamUtilities } from 'utilities/dreamteamUtilities';
import { ReactGACategories } from 'constants/appEnums';
import routes from 'constants/routes';
import './BonusButton.scss';

const BonusButton: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const onBonusButtonClick = () => {
    dreamteamUtilities.recordEventGA(ReactGACategories.nav, 'Went to bonus cards page');
    history.push({ pathname: routes.BONUS.route, search: window.location.search });
  };

  const ref = useRef<HTMLButtonElement>(null);

  // Slight delayed show of button to give time for space to become available on the slider
  useEffect(() => {
    const showButton = () => {
      if (ref.current) ref.current.classList.add('bonus-nav-button--show');
    };

    const timeout = setTimeout(showButton, 450);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <button ref={ref} className="bonus-nav-button" onClick={onBonusButtonClick} data-testid="bonus-button">
      <BonusIcon width={16} height={16} />
      <div className="bonus-nav-button__text">{t('bonus')}</div>
    </button>
  );
};

export default BonusButton;
